import React from "react";
import { useTranslation } from 'react-i18next';
import {Row} from "react-bootstrap";
import CustomCard from "../../components/CustomCard";
import CardForm from "../../components/form/CardForm";

const MachineAdditionalData = ({format, config, setLoader, reload, readOnly, additionalData, setAdditionalData}) => {

    const { t } = useTranslation();

    return (
        <>
            <Row>
                {<CustomCard
                    width={12}
                    withoutHeader={true}>
                    <strong>
                        {t("common.details")}
                    </strong>

                </CustomCard>}
            </Row>
            <Row>
                <CardForm
                    setLoader={setLoader}
                    fields={config.fieldsConfig}
                    width={12}
                    initialData={additionalData}
                    withoutHeader={true}
                    noActions={true}
                    readOnly={readOnly}
                    disableInvalidAlert={true}
                    disableLoader={true}
                    formDataChanged={setAdditionalData}
                />


            </Row>

        </>
    );
};


export default MachineAdditionalData;